import { Box, Title } from '@bottlebooks/gatsby-design-system';

export default function OldPageTitle({ children, ...rest }) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Title>{children}</Title>
    </Box>
  );
}
